/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_DomuhqInputs */

const cs_enum_domuhq = /** @type {(inputs: Enum_DomuhqInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DomuHQ`)
};

const en_enum_domuhq = /** @type {(inputs: Enum_DomuhqInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DomuHQ`)
};

/**
* | output |
* | --- |
* | "DomuHQ" |
*
* @param {Enum_DomuhqInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_domuhq = /** @type {((inputs?: Enum_DomuhqInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_DomuhqInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_domuhq(inputs)
	return cs_enum_domuhq(inputs)
});